import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  bannerTitulo = 'Tourlander';
  bannerContenido = "Elige una ciudad, busca un tour y realizalo cuando quieras";
  bannerMargen = true;
  bannerBotonTitulo = 'Registrate';
  bannerBotonRuta = '/registro';
  bannerImagen = 'assets/header-home.jpg';

  constructor() { }

  ngOnInit(): void {
  }

}
